'use strict';

angular.module('sellers')
.directive("basicCard", function() {
  return {
    restrict : "A"
    ,templateUrl : "partials/card-basic.html"
    ,transclude : true
    ,link : function($scope, $elem, $attrs) {
      console.log($scope.item);

      $scope.card = {
        header: $scope.item.body.property.address
        ,meta: $scope.item.body.property.priceView
        ,image: $scope.item.body.property.image.large
        ,date: moment.unix($scope.item.date).format("dddd, MMMM Do YYYY, h:mm:ss a")
        ,body: "New sale in feed"
      };


    }
  };
});
